
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from '@/components/ui/dialog';
import { PEOProviderForm } from '@/components/admin/peo/PEOProviderForm';
import { usePEOProviders } from '@/components/admin/peo/hooks/usePEOProviders';
import { ErrorBoundary } from '@/components/ui/error-boundary';
import type { PEOProvider } from '@/types/peo.types';

interface PEOProviderDialogProps {
  isOpen: boolean;
  onOpenChange: (open: boolean) => void;
  selectedProvider?: PEOProvider;
  onSuccess: () => void;
}

export const PEOProviderDialog = ({
  isOpen,
  onOpenChange,
  selectedProvider,
  onSuccess
}: PEOProviderDialogProps) => {
  console.log('PEOProviderDialog render - isOpen:', isOpen, 'selectedProvider:', selectedProvider?.name);
  
  const { handleProviderDelete, isDeletingProvider, refetch } = usePEOProviders();

  const handleCloseDialog = () => {
    console.log('Dialog closing, triggering refetch and onSuccess');
    // Refetch data to ensure we have the latest
    refetch();
    
    // Call the onSuccess callback
    onSuccess();
    
    // Close dialog
    onOpenChange(false);
  };

  const handleOpenChange = (open: boolean) => {
    console.log('Dialog open change:', open);
    onOpenChange(open);
  };

  console.log('PEOProviderDialog: About to render Dialog component');

  return (
    <Dialog open={isOpen} onOpenChange={handleOpenChange}>
      <DialogContent className="max-w-2xl max-h-[90vh] overflow-y-auto">
        <DialogHeader>
          <DialogTitle>
            {selectedProvider ? 'Edit PEO Provider' : 'Add PEO Provider'}
          </DialogTitle>
          <DialogDescription>
            {selectedProvider 
              ? `Update information for ${selectedProvider.name}`
              : 'Enter details for the new PEO provider'}
          </DialogDescription>
        </DialogHeader>
        <ErrorBoundary>
          <PEOProviderForm 
            provider={selectedProvider}
            onSuccess={handleCloseDialog}
            onClose={handleCloseDialog}
            onDeleteProvider={handleProviderDelete}
            isDeleteInProgress={isDeletingProvider}
          />
        </ErrorBoundary>
      </DialogContent>
    </Dialog>
  );
};
